import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=873be52e&scoped=true&"
import script from "./ConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationPage.vue?vue&type=style&index=0&id=873be52e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873be52e",
  null
  
)

export default component.exports